import {useCallback, useLayoutEffect, useRef} from 'react';

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param value the value or function to persist
 */
// eslint-disable-next-line typescript/no-explicit-any -- Pre-existing any
export function useCallbackRef<T extends (...args: any[]) => any>(
  fn: T | undefined,
  deps: React.DependencyList = []
): T {
  const ref = useRef(fn);

  useLayoutEffect(() => {
    ref.current = fn;
  });

  // eslint-disable-next-line react/exhaustive-deps
  // eslint-disable-next-line react/react-compiler, react/exhaustive-deps -- pre-existing, tracked by T20-137202. Muted pre-existing violation
  return useCallback(((...args) => ref.current?.(...args)) as T, deps);
}
